import { Injectable } from '@angular/core';
import {Http, Response} from "@angular/http";
import { Headers, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Client} from "../model/Client";
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";

@Injectable()
export class ClientService {

    clientUrl = environment.instantPaiementApi + "clients";

    constructor(private http: Http,
                private authenticationService: AuthenticationService) {}


    getClient(email: string): Promise<Client> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.get(this.clientUrl + "/" + email, options)
            .toPromise()
            .then(response => response.json() as Client)
            .then(undefined, (error) => { return null; })
            .catch(this.handleError);
        //return Promise.resolve(this.menu);
    }

    addClient(client:Client): Promise<Client> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.clientUrl, client, options).toPromise()
            .then(response => response.json() as Client)
            .then(undefined, (error) => { return error; })
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body as Client;
    }

    handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/client.service.ts